import { copy } from "./copy";

export interface Comparison {
  domain: string;
  today: {
    label: string;
    title: string;
    body: string;
    chips: string[];
  };
  neuro: {
    label: string;
    title: string;
    body: string;
    chips: string[];
  };
}

export const comparisons: Comparison[] = [
  {
    domain: "kubernetes",
    today: {
      label: "Today",
      title: "A code editor with no cluster behind it.",
      body: "Candidate writes pseudo-controller code. You ask what they'd run. Nobody learns anything.",
      chips: ["editor.html", "stdout", "no cluster"],
    },
    neuro: {
      label: `With ${copy.brand}`,
      title: "A live k3s cluster in their browser.",
      body: "kubectl, kubebuilder, k9s on the right. They write a real controller. You watch the cluster state update as they apply CRDs.",
      chips: ["k3s", "kubectl", "k9s", "kubebuilder"],
    },
  },
  {
    domain: "llvm",
    today: {
      label: "Today",
      title: "Whiteboard questions about SSA form.",
      body: "Tests whether the candidate has memorized theory. Says nothing about whether they can write a pass that compiles.",
      chips: ["whiteboard", "verbal", "no API"],
    },
    neuro: {
      label: `With ${copy.brand}`,
      title: "A real LLVM toolchain with a live IR viewer.",
      body: "clangd flags errors as they type. opt and llvm-lit are in the terminal. The IR tree updates as they modify the pass.",
      chips: ["clang", "opt", "llvm-lit", "live IR"],
    },
  },
  {
    domain: "sre",
    today: {
      label: "Today",
      title: "“Tell me about a time you handled an incident.”",
      body: "Easy to embellish. Tells you about storytelling, not investigation. The pain is verbal, the fix is verbal.",
      chips: ["behavioral", "anecdote", "no signal"],
    },
    neuro: {
      label: `With ${copy.brand}`,
      title: "A real broken cluster.",
      body: "Grafana with elevated errors. Loki with the logs. kubectl on the affected cluster. Watch how they actually debug.",
      chips: ["Grafana", "Loki", "kubectl", "live metrics"],
    },
  },
];
